export default "__VITE_ASSET__BDOVlkpB__"